export const videosPath = {
  /* inject path */
  VIDEO_VIEW: '/videos/video-view/:id',
  VIDEO_VIEW_URI: '/videos/video-view',
  ADD_VIDEO: '/videos/add-video',
  VIDEOS_TABLE: '/videos/videos-table',
  DASHBOARD: '/videos/dashboard',
  COMPARE_VIDEOS: '/videos/compare-videos',
  TOP_COUNTRIES_WORLD_MAP: '/videos/top-countries-map',
};
